import 'swiper/swiper.min.css';

import React, { useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import { translate } from 'react-i18next';

import CardWithImage from '../Card/CardWithImage';
import PropTypes from 'prop-types';
import { media } from '../../styles/media';
import styled from 'styled-components';

import 'swiper/modules/pagination/pagination.min.css';

const SliderWrapper = styled(Swiper)`
  width: 100%;
  overflow: unset !important;
  position: relative !important;
  z-index: 3 !important;

  .swiper-slide {
    height: auto;
  }

  .swiper-pagination {
    display: flex;
    justify-content: center;
    bottom: -25px !important;
  }

  .swiper-pagination-bullet {
    display: ${({ hide }) => (hide ? 'none' : 'block')};
    height: 2px;
    width: 12px;
    margin-right: 7px;
    border-radius: 0px;
    background-color: ${({ theme }) => theme.color.brand.lightGrey2};
    transition: all 0.3s ease;
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    width: 42px;
    background-color: ${({ theme }) => theme.color.brand.accent};
  }
`;

const SlideWrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;

  ${media.tablet`
    display: block;
  `};
`;

const EventSlidesCarousel = ({ slides, isMobile, t }) => {
  const enableSwipe = useMemo(() => isMobile || slides.length > 3, [isMobile]);

  return (
    <SliderWrapper
      initialSlide={1}
      slidesPerView={isMobile ? 1 : 'auto'}
      spaceBetween={50}
      modules={[Pagination]}
      pagination={{ enabled: enableSwipe, clickable: true }}
      centeredSlides={!isMobile}
      allowSlideNext={enableSwipe}
      allowSlidePrev={enableSwipe}
    >
      {slides.map((slide, index) => {
        const { detail } = slide;

        const slideDetail = {
          title: detail?.name,
          date: detail?.date,
          image: {
            url: slide.visual_desktop,
            alt: detail?.title,
            height: isMobile ? 305 : 360,
            width: isMobile ? 305 : 360
          },
          link: `${t('common:brands.navigation.events')}/${slide?.category
            ?.detail?.slug || 'uncategorized'}/${detail.slug}`
        };

        return (
          <SwiperSlide
            key={`event-slide-${index}`}
            style={{
              maxWidth: isMobile ? 'unset' : '360px'
            }}
          >
            <SlideWrapper>
              <CardWithImage
                card={slideDetail}
                maxWidth={isMobile ? 305 : 360}
                minWidth={isMobile ? 305 : 360}
                fullHeight
              />
            </SlideWrapper>
          </SwiperSlide>
        );
      })}
    </SliderWrapper>
  );
};

EventSlidesCarousel.propTypes = {
  slides: PropTypes.array,
  isMobile: PropTypes.bool,
  t: PropTypes.func
};

export default translate()(EventSlidesCarousel);
